// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ISsoUserSignUpDto
 */
export interface ISsoUserSignUpDto {
    /**
     * 
     * @type {string}
     * @memberof ISsoUserSignUpDto
     */
    new_user_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ISsoUserSignUpDto
     */
    new_password?: string;
    /**
     * 
     * @type {string}
     * @memberof ISsoUserSignUpDto
     */
    confirm_password?: string;
    /**
     * 
     * @type {string}
     * @memberof ISsoUserSignUpDto
     */
    personal_email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ISsoUserSignUpDto
     */
    is_electronic_statement_only?: boolean;
}

/**
 * Check if a given object implements the ISsoUserSignUpDto interface.
 */
export function instanceOfISsoUserSignUpDto(value: object): value is ISsoUserSignUpDto {
    return true;
}

export function ISsoUserSignUpDtoFromJSON(json: any): ISsoUserSignUpDto {
    return ISsoUserSignUpDtoFromJSONTyped(json, false);
}

export function ISsoUserSignUpDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISsoUserSignUpDto {
    if (json == null) {
        return json;
    }
    return {
        
        'new_user_name': json['new_user_name'] == null ? undefined : json['new_user_name'],
        'new_password': json['new_password'] == null ? undefined : json['new_password'],
        'confirm_password': json['confirm_password'] == null ? undefined : json['confirm_password'],
        'personal_email': json['personal_email'] == null ? undefined : json['personal_email'],
        'is_electronic_statement_only': json['is_electronic_statement_only'] == null ? undefined : json['is_electronic_statement_only'],
    };
}

export function ISsoUserSignUpDtoToJSON(json: any): ISsoUserSignUpDto {
    return ISsoUserSignUpDtoToJSONTyped(json, false);
}

export function ISsoUserSignUpDtoToJSONTyped(value?: ISsoUserSignUpDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'new_user_name': value['new_user_name'],
        'new_password': value['new_password'],
        'confirm_password': value['confirm_password'],
        'personal_email': value['personal_email'],
        'is_electronic_statement_only': value['is_electronic_statement_only'],
    };
}

